// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"e8fabb28","36":"91ada27e","232":"3141490c","263":"7091a1bd","341":"250af722","791":"67f50d6a"}[chunkId] + ".chunk.css";
};